import {metadaApi} from '@dms/api/base';

import {
  type AbcXyzAnalysisDetailResponse,
  AbcXyzAnalysisDetailResponseSchema,
} from './AbcXyzAnalysisDetailResponseSchema';

/**
 * The ABC/XYZ row detail is served by the metada `report` module, so this endpoint injects into
 * `metadaApi`, like `useGetDailyStockTakeByIdQuery`. The module is mounted at `report/v1` and the
 * operation `RPT_get_abcXyzAnalysisDetail_API` is addressed `/abc-xyz-analysis/{dgId}` in the
 * module's OpenAPI document (`teas/api/report/v1/openapi.json`), so the served path has a single
 * `v1`. The stock take details differ: their addresses repeat `v1/report`, hence the doubled
 * `v1` there. An unknown row id answers 404 with the standard Metada error body, a malformed one
 * 400.
 */
const abcXyzAnalysisDetailUrl = (id: string) =>
  `/report/v1/abc-xyz-analysis/${encodeURIComponent(id)}`;

const abcXyzAnalysisEndpoints = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getAbcXyzAnalysisDetail: build.query<AbcXyzAnalysisDetailResponse, string>({
      query: (id) => ({url: abcXyzAnalysisDetailUrl(id)}),
      /**
       * No `providesTags`: the detail is an immutable snapshot of a closed period, and
       * `metadaApi` has no tag type that would fit it.
       */
      extraOptions: {responseSchema: AbcXyzAnalysisDetailResponseSchema},
    }),
  }),
});

// Named rather than destructured so the export is visible to `eag(match-named-export)`.
export const useGetAbcXyzAnalysisDetailQuery =
  abcXyzAnalysisEndpoints.useGetAbcXyzAnalysisDetailQuery;
